export const TouchId = ({
  height = 100,
  width = 100,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2954_9229)">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" fillOpacity="0.5" />
      </g>
      <g clipPath="url(#clip0_2954_9229)">
        <path
          d="M50.0002 28C37.8738 28 28.0002 37.8736 28.0002 50C28.0002 62.1352 37.8738 72 50.0002 72C62.1354 72 72.0002 62.1352 72.0002 50C72.0002 37.8736 62.1354 28 50.0002 28ZM40.8976 36.9968C46.9364 33.7857 53.062 33.7849 59.1043 36.9968C59.5331 37.225 59.6964 37.7578 59.4678 38.1866C59.3097 38.4844 59.0055 38.6537 58.6901 38.6537C58.5508 38.6537 58.4099 38.6206 58.2776 38.5505C52.708 35.59 47.2922 35.5909 41.7243 38.5505C41.2946 38.7787 40.7618 38.6154 40.534 38.1866C40.3055 37.7578 40.4687 37.225 40.8976 36.9968ZM47.5233 64.4014C47.3506 64.5909 47.1126 64.6871 46.8745 64.6871C46.6622 64.6871 46.4491 64.6111 46.2807 64.4564C41.3101 59.9086 41.0222 54.4709 42.4101 50.8985C43.7447 47.4618 46.6537 45.3271 50.0009 45.3271C55.47 45.3271 58.0094 50.3369 58.5878 52.9859C58.6918 53.4598 58.3919 53.9278 57.9175 54.0322C57.4448 54.1383 56.9739 53.8371 56.869 53.3632C56.8123 53.1071 55.4107 47.0871 50.0009 47.0871C47.3962 47.0871 45.1162 48.7917 44.0506 51.5361C42.8733 54.5654 43.1534 59.2095 47.4683 63.1579C47.8267 63.4862 47.8516 64.0426 47.5233 64.4014ZM59.2401 62.3432C59.1361 62.7385 58.7794 63.0006 58.3893 63.0006C58.3154 63.0006 58.2397 62.9912 58.165 62.9714C50.1754 60.8771 48.7823 54.5732 48.7265 54.3059C48.6285 53.8298 48.9336 53.364 49.4097 53.2656C49.8797 53.1646 50.3498 53.471 50.4495 53.9458C50.5002 54.1787 51.7197 59.4626 58.6119 61.269C59.0819 61.3923 59.363 61.8731 59.2401 62.3432ZM61.5526 55.9757C60.4389 57.3777 58.8688 58.0558 57.2472 57.8431C55.1924 57.5702 53.3147 55.9005 52.2267 53.3756C51.6965 52.145 51.0107 51.4721 50.1891 51.3741C49.1132 51.2487 47.9187 52.099 47.4322 52.7483C47.0722 53.2287 46.7284 54.6415 47.2578 56.5639C47.7494 58.3471 49.3306 61.6484 54.3958 63.7259C54.8452 63.9103 55.0601 64.4246 54.8753 64.8741C54.7361 65.2144 54.4078 65.4202 54.0615 65.4206C53.9497 65.4206 53.8372 65.3991 53.7272 65.3545C47.9676 62.9916 46.1389 59.1257 45.5614 57.0318C44.983 54.9345 45.1652 52.8385 46.0246 51.6921C46.7396 50.7378 48.4884 49.4006 50.3971 49.6266C51.4215 49.7482 52.8506 50.3768 53.8423 52.6787C54.6837 54.6295 56.0432 55.9078 57.4783 56.0986C58.4872 56.2313 59.4455 55.8004 60.1742 54.8817C61.1401 53.6639 60.9631 52.1325 60.6443 51.0618C59.7763 48.1511 56.9558 45.3821 53.7839 44.329C48.8906 42.7018 43.2333 44.9606 40.9105 49.4702C38.6374 53.8818 40.9199 59.6035 40.9431 59.6611C41.1262 60.1105 40.9105 60.6245 40.461 60.8079C40.009 60.9905 39.4985 60.777 39.3137 60.3271C39.2063 60.0633 36.6969 53.8057 39.3464 48.6641C42.0551 43.4039 48.6414 40.7669 54.339 42.6584C58.0816 43.9014 61.2931 47.0768 62.3304 50.5595C62.9508 52.6391 62.6741 54.5629 61.5526 55.9757ZM62.7369 46.657C62.3269 46.9187 61.783 46.795 61.5226 46.3846C59.1524 42.642 54.4886 40.4193 49.3143 40.5718C44.5258 40.7183 40.3845 42.9278 38.5068 46.3382C38.3461 46.6291 38.0453 46.7937 37.7351 46.7937C37.5915 46.7937 37.4463 46.7589 37.3114 46.6845C36.886 46.4499 36.7305 45.915 36.9651 45.4891C39.1745 41.4763 43.7713 38.9802 49.261 38.8127C55.0197 38.6399 60.3091 41.1768 63.0093 45.4427C63.2697 45.8535 63.1476 46.3971 62.7369 46.657Z"
          fill="#262626"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2954_9229"
          x="-24"
          y="-24"
          width="148"
          height="148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2954_9229"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2954_9229"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2954_9229">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(28 28)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
